import { render, staticRenderFns } from "./HeaderSchool.vue?vue&type=template&id=1f06ec2d&scoped=true"
import script from "./HeaderSchool.vue?vue&type=script&lang=js"
export * from "./HeaderSchool.vue?vue&type=script&lang=js"
import style0 from "./HeaderSchool.vue?vue&type=style&index=0&id=1f06ec2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f06ec2d",
  null
  
)

export default component.exports